import { v4 } from "uuid";
export const general = {
  raise_query: false,
  required: false,
  display_visuals_line: "none",
  remove_heading: false,
  disable: false,
};

export const note = {
  message_note: "",
};
export const input_text = {
  default_val: "",
  restrict_number: "",
  restrict_spl_char: "",
  restrict_email: false,
  max_limit: "",
  max_limit_range: "",
  min_limit: "",
  min_limit_range: "",
  measurement_unit_text: "",
};

export const toggle = {
  toggle_msg_1: "",
  toggle_msg_2: "",
  display_visuals_line: "",
  default_msg: "",
};

export const input_number = {
  default_val: null,
  measurement_unit: "",
  positive_number: false,
  whole_number: false,
  restrict_text: false,
  decimal_notation: false,
  decimal_notation_places: "",
  scientific_notation: false,
  scientific_exponent_notation: "",
  max_limit: false,
  max_limit_range: "",
  min_limit: false,
  min_limit_range: "",
};

export const input_email = {
  input_email_format: false,
};

export const input_current_time = {
  time_format: "",
  time_display_format: "",
  time_greater_than: "",
  time_less_than: "",
};

export const input_date = {
  date_display_format: "",
  min_date_enabled: false, //
  min_date: "",
  max_date_enabled: false,
  max_date: "",
  future_only: false,
  past_only: false,
  date_range: false,
  current_date: false,
  default_date: "",
};

export const input_date_and_time = {
  time_format: "",
  time_display_format: "",
  date_display_format: "",
};

export const linked_field = {
  section: "",
  linked_field: "",
  default_val: "",
};

export const LinkedFieldSchema = {
  linked_field: {
    template_id: "",
    template_version: "",
    section_uuid: "",
    linked_field: "",
    default_val: 0,
  },
};
export const DependencyFieldSchema = {
  comparison_type: "",
  linked_field: "",
};

export const hyperlink = {
  name: "",
  url: "",
};

export const barcode = {
  format: "",
  linked_field: "",
  default_val: "",
};

export const file_upload = {
  allow_pdf_file_only: "",
  allow_other_file_format: "",
  allow_multi_upload: "",
  multi_upload_limit: "",
  size_per_file: "",
  file_size_unit: "",
};
export const input_dropdown = {
  is_master: false,
  is_dependent: false,
  source_endpoint: null,
  dependent_endpoint: null,
  dependent_query_params: [],
  depends_on: null,
  is_visible: true,
  is_data_visible: false,
};

export const image_upload = {
  allow_jpg_only: "",
  allow_other_format: "",
  allow_multi_upload: "",
  multi_upload_limit: "",
  size_per_file: "",
  file_size_unit: "",
  image_dimension: "",
};
// @info other schema of secondary form
export const DropdownSchema = {
  options: [],
  default_val: "",
};

export const ConditionSchema = () => ({
  target_input_field_uuid: [],
  option_uuid: "",
});

export const ConditionsSchema = {
  conditions: [ConditionSchema()],
};
export const optionConditionSchema = () => ({
  target_input_field_uuid: "", // also fix this (should be string, not array)
  option_uuid: "",
  allowed_options: [],
});

export const OptionsConditionSchemas = {
  conditions: [optionConditionSchema()],
};

export const InputVariableSchema = () => ({
  name: "",
  linked_field_uuid: "",
  default_val: null,
});

export const ReferenceVariableSchema = {
  input_calculation_variables: [InputVariableSchema()],
};

export const ValidationSchema = {
  validation_type_id: "",
  regex_pattern: "",
  message: "",
};
export const input_radio = {
  is_horizontal: false,
};
export const RadioSchema = {
  options: [
    {
      value: "",
      label: "",
    },
  ],
  // default_val: '',
};

//@info here conditions: [], validations: [] is called in the every default value but might not required.
export const fieldTypeDefaults = {
  Label: { general, note },
  Toggle: { general, note, toggle },
  "Input Text": { general, note, input_text },
  "Input Radio": { general, note, input_radio },
  "Input Dropdown": { general, note, input_dropdown },
  "Input Number": { general, note, input_number },
  "Input Email": { general, note, input_email },
  "Input Current Time": { general, note, input_current_time },
  "Input Date": { general, note, input_date },
  "Input Date and Time": { general, note, input_date_and_time },
  "Linked Field": { general, note },
  Hyperlink: { general, note, hyperlink },
  "File Upload": { general, note, file_upload },
  "Image Upload": { general, note, image_upload },
};
export const FieldSchema = {
  input_uuid: v4(),
  label: "Untitled field",
  placeholder: "Enter field title",
  order: 1,
  property: {
    field_layout: 12,
    field_type: "Input Text",
    general,
    note,
    input_text,
    // conditions: [],
    // validations: []
  },
};

export const SectionSchema = {
  section_uuid: v4(),
  name: "Untitled section",
  description: "", //@info removing default value as it is not madantory now
  order: 1,
  property: {
    display_details: true,
    display_field_number: false,
    type: "none",
  },
  fields: [FieldSchema],
};

export const buildPermissionInitialValues = (formSections = []) => ({
  sections: formSections.map((section) => ({
    permissions: [
      {
        view: section?.persmissions?.view?.map((p) => p.role_id) || [],
        fill: section?.persmissions?.fill?.map((p) => p.role_id) || [],
      },
    ],
  })),
});
